import type { OnInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PlatformService } from '@core/platform';
import { InnogyComponentRendering } from '@core/jss-models';
import { getDropTreeValue, getFieldValue } from '@core/jss-utils';
import { WINDOW } from '@innogy/utils-dom';
import type { Item } from '@sitecore-jss/sitecore-jss/layout';

import type { ShareButton } from '../share-buttons.model';

@Component({
  selector: 'wl-share-buttons-container',
  templateUrl: './share-buttons-container.component.html',
  styleUrls: [
    '../share-buttons.component.essent.scss',
    '../share-buttons.component.ed.scss',
  ],
})
export class ShareButtonsContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  currentUrl?: string;
  currentPageTitle?: string;
  items?: ShareButton[];

  constructor(
    private readonly title: Title,
    private readonly platformService: PlatformService,
    @Inject(WINDOW) private readonly windowRef: Window | null
  ) {}

  ngOnInit() {
    if (this.platformService.isClient() && this.windowRef) {
      this.currentUrl = this.windowRef.location.href;
    }

    this.currentPageTitle = this.title.getTitle();
    this.items = this.renderingToModel();
  }

  public renderingToModel(): ShareButton[] {
    const channels = getDropTreeValue<Item[]>(
      this.rendering?.fields,
      'socialChannels',
      []
    );

    return channels
      .filter((channel) => !!channel.fields['icon'])
      .map((channel) => ({
        icon: channel.fields['icon'] as Item,
        name: getFieldValue<string>(channel.fields, 'name'),
        cssName: getFieldValue<string>(channel.fields, 'cssName'),
        url: this.replacePlaceholders(
          getFieldValue<string>(channel.fields, 'url', ''),
          this.currentUrl,
          this.currentPageTitle
        ),
      }));
  }

  replacePlaceholders(
    url: string,
    pageUrl?: string,
    pageTitle?: string
  ): string {
    return url
      .replace('{{URL}}', pageUrl ? encodeURIComponent(pageUrl) : '{{URL}}')
      .replace(
        '{{Title}}',
        pageTitle ? encodeURIComponent(pageTitle) : '{{Title}}'
      );
  }
}
